import { render, staticRenderFns } from "./AnswersCheckboxes.vue?vue&type=template&id=36314e16&scoped=true"
import script from "./AnswersCheckboxes.vue?vue&type=script&lang=js"
export * from "./AnswersCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./AnswersCheckboxes.vue?vue&type=style&index=0&id=36314e16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36314e16",
  null
  
)

export default component.exports